<template>
	<div>
        <EmpresaDialog :dialog="dialog" :empresaId="empresaId" :empresaToken="empresaToken" :insert="insert" @dialogClose="dialogClose" />
		<v-card>
			<v-card-title>
				<v-icon color="primary" left>location_city</v-icon>Cadastro de Empresas
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-text-field v-model="search" append-icon="search" label="Pesquisar pelo Nome, Fantasia ou CNPJ" single-line hide-details/>
					</v-col>
				</v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="12">
						<v-btn depressed color="primary"  v-if="userAdmin" @click="buttonAddEmpresa">NOVA EMPRESA</v-btn>
					</v-col>
                </v-row>
				<v-data-table
					:headers="headers"
					:items="empresas"
					:options.sync="options"
					:server-items-length="total"
					class="elevation-1"
					:loading="loading"
					@click:row="empresaSelected">
				</v-data-table>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
import EmpresaDialog from '@/components/empresas/EmpresaDialog'
import { mapGetters } from "vuex";

export default {
    components: { EmpresaDialog },
	data: function() {
		return {
			empresas: [],
			search: '',
			headers: [
				{ text: 'CPF/CNPJ', value: 'cpfcnpj' },
				{ text: 'Nome', value: 'nomerazao' },
				{ text: 'Fantasia', value: 'nomefantasia' },
				{ text: 'UF', value: 'uf' },
				{ text: 'Cidade', value: 'cidade' },
				{ text: 'WhatsApp', value: 'whatsapp' }
			],
			options: {},
			loading: false,
            total: 0,
            dialog: false,
            empresaId: '',
            empresaToken: '',
            insert: false
		}
	},
	computed: {
    ...mapGetters(["userAdmin", "userMaster"]),
	},
	methods: {
		async loadEmpresas() {
			try {
				if (this.loading) return

				this.loading = true
				const { sortBy, sortDesc, page, itemsPerPage } = this.options

				const response = await this.axios.get('/empresas', {
					params: {
						page,
						limit: itemsPerPage,
						sortBy: sortBy[0],
						sortDesc: sortDesc[0],
						search: this.search,
					}
				})
				this.empresas = response.data.empresas
				this.total = response.data.total
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		loadEmpresasSearch() {
			this.options.page = 1
			this.loadEmpresas()
		},
		async empresaSelected(empresa) {
            this.dialog = true
            this.insert = false
            this.empresaId = empresa.id
            this.empresaToken = empresa.api_key
		},
		dialogClose() {
			this.empresaId = ''
            this.empresaToken = ''
            this.insert = false
			this.dialog = false
			this.loadEmpresas()
        },
        buttonAddEmpresa(){
            this.dialog = true
            this.insert = true
        },
	},
	watch: {
		options: {
			handler() {
				this.loadEmpresas()
			},
			deep: true
		},
		search() {
			if (this.search.length > 3 || this.search.length == 0) this.loadEmpresasSearch()
		},
	}
}
</script>
